export const ENV = {
  ports: process.env.PORTS,

  connection: {
    server_base_url: process.env.REACT_APP_SERVER_BASE_URL,
    websocket_base_url: process.env.REACT_APP_WEBSOCKET_BASE_URL
  },

  keys: {
    cryptr_key: process.env.REACT_APP_CRYPTR_KEY,
    google_recaptcha_site_key: process.env.REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY,
    client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID
  },

  colors: {
    primary_color: process.env.REACT_APP_PRIMARY_COLOR,

    default_color: process.env.REACT_APP_BACKGROUND_COLOR,
    paper_color: process.env.REACT_APP_PAPER_COLOR,

    primary_text: process.env.REACT_APP_TEXT_PRIMARY_COLOR,
    primary_medium_text: process.env.REACT_APP_TEXT_PRIMARY_MEDIUM_COLOR,
    primary_small_text: process.env.REACT_APP_TEXT_PRIMARY_SMALL_COLOR,
    secondary_text: process.env.REACT_APP_TEXT_SECONDARY_COLOR,
    red: process.env.REACT_APP_RED_COLOR,
    green: process.env.REACT_APP_GREEN_COLOR,
    yellow: process.env.REACT_APP_YELLOW_COLOR,
    blue: process.env.REACT_APP_BLUE_COLOR,
    stroke: process.env.REACT_APP_STROKE_COLOR
  },

  product_name: process.env.REACT_APP_PRODUCT_NAME,
  product_logo: process.env.REACT_APP_PRODUCT_LOGO,

  product_url: process.env.REACT_APP_PRODUCT_URL,

  product_mail: process.env.REACT_APP_PRODUCT_MAIL,

  terms_conditions: process.env.REACT_APP_TERMS_CONDITIONS,
  privacy_policy: process.env.REACT_APP_PRIVACY_POLICY,
  contact_us: process.env.REACT_APP_CONTACT_US
}
